import type { AppProps } from 'next/app'
import localFont from 'next/font/local'
import React from 'react'
import { useLoadingState } from '@dustin-web/microsite-components/src/hooks'
import { useFocusVisiblePolyfill } from '@dustin-web/microsite-components/src/hooks/use-focus-visible'
import ProgressBar from '@dustin-web/microsite-components/src/progress/progress-bar'

const DustinSans = localFont({
  src: [
    {
      path: '../../../styledust/fonts/DustinSans-Light.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../../../styledust/fonts/DustinSans-LightItalic.woff2',
      weight: '300',
      style: 'italic',
    },
    {
      path: '../../../styledust/fonts/DustinSans-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../../styledust/fonts/DustinSans-RegularItalic.woff2',
      weight: '400',
      style: 'italic',
    },
    {
      path: '../../../styledust/fonts/DustinSans-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../../../styledust/fonts/DustinSans-BoldItalic.woff2',
      weight: '700',
      style: 'italic',
    },
  ],
})

const DustinIcons = localFont({
  src: [
    {
      path: '../../../microsite-components/src/icon-library/assets/DustinIcons.woff2',
      weight: '400',
      style: 'normal',
    },
  ],
  variable: '--font-dustin-icons',
  display: 'swap',
})

const DustinApp = ({ Component, pageProps, devUtils }: AppProps & { devUtils: any }) => {
  // TODO: isLoading is not future proof since router.events is deprecated in nextjs v13, perhaps use nextjs-toploader instead?
  const { isLoading } = useLoadingState()
  useFocusVisiblePolyfill()

  return (
    <div className={`${DustinSans.className} ${DustinIcons.variable}`}>
      <ProgressBar isRouteChanging={isLoading} />
      <Component {...pageProps} devUtils={devUtils} />
    </div>
  )
}

export default DustinApp
